import {SuccessesGreenIcon} from "@/app/[locale]/common/assets/SuccessesGreenIcon/SuccessesGreenIcon";
import {ErrorRedColor} from "@/app/[locale]/common/assets/ErrorRedColor/ErrorRedColor";

export const NAME_VALIDATE = {
    required: { value: true, message: 'The field is required for submission' },
    minLength: {value: 2, message: 'Minimum characters long'},
    pattern: { value: /^[a-zA-Z]+([- ][a-zA-Z]+)*$/, message: 'Only Latin letters are allowed' },
};

export const PHONE_VALIDATE = {
    minLength: {value: 5, message: 'Minimum characters long'},
    maxLength: {value: 20, message: 'Maximum character length'},
    pattern: {
        value: /^\+?[0-9]{1,3}?[-. (]*\d{1,4}[-. )]*\d{1,4}[-. ]*\d{1,4}[-. ]*\d{1,9}$/,
        message: 'Invalid phone number format'
    },
};

export const EMAIL_VALIDATE = {
    required: {  value: true, message: 'The field is required for submission' },
    minLength: {value: 6, message: 'Minimum characters long'},
    pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: 'Invalid email format'
    },
};

export const LABEL_MESSAGES = {
    NAME: 'Name',
    PHONE: 'Phone',
    EMAIL: 'Email',
    MESSAGE: 'Message',
} as const;

export const LABEL_MESSAGES_PH = {
    NAME: 'Pangalan',
    PHONE: 'Telepono',
    EMAIL: 'Email',
    MESSAGE: 'Mensahe',
} as const;

export const MESSAGES = {
    SUCCESS: {
        title: 'Thank you',
        description: 'Your message has been sent successfully',
        Icon: SuccessesGreenIcon,
    },
    ERROR: {
        title: 'Error',
        description: 'Something went wrong. Please, try again!',
        Icon: ErrorRedColor,
    },
};

export const MESSAGES_PH = {
    SUCCESS: {
        title: 'Salamat',
        description: 'Matagumpay na naipadala ang iyong mensahe',
    },
    ERROR: {
        title: 'Error',
        description: 'May nangyaring problema. Pakiusap, subukang muli!',
    },
};